import { IonCol, IonLabel, IonRow } from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import './pulses.content.css'
import SingleSelect from '../../../../../components/singleSelect/SingleSelect.component'
import { useDispatch, useSelector } from 'react-redux'
import { getCardioOptionsSelector } from '../../../../options/selectors'
import {
  setPulseCarotid,
  setPulseCarotidR,
  setPulseBraL,
  setPulseBraR,
  setPulseDorsL,
  setPulseDorsR,
  setPulseFemL,
  setPulseFemR,
  setPulseRadL,
  setPulseRadR,
  savePulses,
} from '../store/pulses.actions'
import { IOption } from '../../../../../common/common.types'
import { getPulsesSelector } from '../selectors/pulses.selector'
import { getDatapointsConfigSelector } from '../../../../configurations/selectors'

const PulsesContent: React.FC = () => {
  const { t } = useTranslation()

  const cardioOptions = useSelector(getCardioOptionsSelector)
  const pulses = useSelector(getPulsesSelector)
  const {
    pulseBraL,
    pulseBraR,
    pulseCarotid,
    pulseCarotidR,
    pulseDorsL,
    pulseDorsR,
    pulseFemL,
    pulseFemR,
    pulseRadL,
    pulseRadR,
  } = pulses
  const { pulsesOptions } = cardioOptions
  const dispatch = useDispatch()
  const dataPointsConfig = useSelector(getDatapointsConfigSelector)
  const { DP_PULSE_DORS } = dataPointsConfig

  const save = () => {
    dispatch(savePulses())
  }

  const setCarotIdLeft = (option: IOption) => {
    dispatch(setPulseCarotid(option))
    save()
  }

  const setCarotIdRight = (option: IOption) => {
    dispatch(setPulseCarotidR(option))
    save()
  }

  const setBrachialLeft = (option: IOption) => {
    dispatch(setPulseBraL(option))
    save()
  }

  const setBrachialRight = (option: IOption) => {
    dispatch(setPulseBraR(option))
    save()
  }

  const setDorsalisLeft = (option: IOption) => {
    dispatch(setPulseDorsL(option))
    save()
  }

  const setDorsalisRight = (option: IOption) => {
    dispatch(setPulseDorsR(option))
    save()
  }

  const setFemoralLeft = (option: IOption) => {
    dispatch(setPulseFemL(option))
    save()
  }

  const setFemoralRight = (option: IOption) => {
    dispatch(setPulseFemR(option))
    save()
  }

  const setRadialLeft = (option: IOption) => {
    dispatch(setPulseRadL(option))
    save()
  }

  const setRadialRight = (option: IOption) => {
    dispatch(setPulseRadR(option))
    save()
  }

  return (
    <>
      <IonRow className='cardioAccordianRowHeader'>
        <IonCol size={'6'} className='cardioAccordianColHeader'>
          <IonLabel>{t('cardio.pulses.left')}</IonLabel>
        </IonCol>

        <IonCol size={'6'} className='cardioAccordianColHeader'>
          <IonLabel>{t('cardio.pulses.right')}</IonLabel>
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol className='picklist' size={'6'}>
          <SingleSelect
            dataTestID='CarotidLeft'
            selectedOption={pulseCarotid}
            listHeader={t('cardio.pulses.CarotidLeft')}
            label={t('cardio.pulses.Carotid')}
            options={pulsesOptions}
            action={setCarotIdLeft}
          />
          <hr className='field-divider' />
        </IonCol>
        <IonCol className='picklist' size={'6'}>
          <SingleSelect
            dataTestID='CarotidRight'
            selectedOption={pulseCarotidR}
            listHeader={t('cardio.pulses.CarotidRight')}
            label={t('cardio.pulses.Carotid')}
            options={pulsesOptions}
            action={setCarotIdRight}
          />
          <hr className='field-divider' />
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol className='picklist' size={'6'}>
          <SingleSelect
            dataTestID='RadialLeft'
            selectedOption={pulseRadL}
            listHeader={t('cardio.pulses.RadialLeft')}
            label={t('cardio.pulses.Radial')}
            options={pulsesOptions}
            action={setRadialLeft}
          />
          <hr className='field-divider' />
        </IonCol>
        <IonCol className='picklist' size={'6'}>
          <SingleSelect
            dataTestID='RadialRight'
            selectedOption={pulseRadR}
            listHeader={t('cardio.pulses.RadialRight')}
            label={t('cardio.pulses.Radial')}
            options={pulsesOptions}
            action={setRadialRight}
          />
          <hr className='field-divider' />
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol className='picklist' size={'6'}>
          <SingleSelect
            dataTestID='BrachialLeft'
            selectedOption={pulseBraL}
            listHeader={t('cardio.pulses.BrachialLeft')}
            label={t('cardio.pulses.Brachial')}
            options={pulsesOptions}
            action={setBrachialLeft}
          />
          <hr className='field-divider' />
        </IonCol>
        <IonCol className='picklist' size={'6'}>
          <SingleSelect
            dataTestID='BrachialRight'
            selectedOption={pulseBraR}
            listHeader={t('cardio.pulses.BrachialRight')}
            label={t('cardio.pulses.Brachial')}
            options={pulsesOptions}
            action={setBrachialRight}
          />
          <hr className='field-divider' />
        </IonCol>
      </IonRow>

      <IonRow>
        <IonCol className='picklist' size={'6'}>
          <SingleSelect
            dataTestID='FemoralLeft'
            selectedOption={pulseFemL}
            listHeader={t('cardio.pulses.FemoralLeft')}
            label={t('cardio.pulses.Femoral')}
            options={pulsesOptions}
            action={setFemoralLeft}
          />
          <hr className='field-divider' />
        </IonCol>
        <IonCol className='picklist' size={'6'}>
          <SingleSelect
            dataTestID='FemoralRight'
            selectedOption={pulseFemR}
            listHeader={t('cardio.pulses.FemoralRight')}
            label={t('cardio.pulses.Femoral')}
            options={pulsesOptions}
            action={setFemoralRight}
          />
          <hr className='field-divider' />
        </IonCol>
      </IonRow>

      {DP_PULSE_DORS === 1 && (
        <IonRow>
          <IonCol className='picklist' size={'6'}>
            <SingleSelect
              dataTestID='DorsalisLeft'
              selectedOption={pulseDorsL}
              listHeader={t('cardio.pulses.DorsalisLeft')}
              label={t('cardio.pulses.Dorsalis')}
              options={pulsesOptions}
              action={setDorsalisLeft}
            />
            <hr className='field-divider' />
          </IonCol>
          <IonCol className='picklist' size={'6'}>
            <SingleSelect
              dataTestID='DorsalisRight'
              selectedOption={pulseDorsR}
              listHeader={t('cardio.pulses.DorsalisRight')}
              label={t('cardio.pulses.Dorsalis')}
              options={pulsesOptions}
              action={setDorsalisRight}
            />
            <hr className='field-divider' />
          </IonCol>
        </IonRow>
      )}
    </>
  )
}

export default PulsesContent
